import { render, staticRenderFns } from "./PortalLinkEditDialog.vue?vue&type=template&id=77eb76b8&"
import script from "./PortalLinkEditDialog.vue?vue&type=script&lang=ts&"
export * from "./PortalLinkEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports